<div>
  <div class="main-container">
    <div class="cover-side-item">
      <span class="cover-side-container">
        <div>
          <img src="{{book().coverImageUrl}}" class="cover-image">
        </div>
        <div>
          <button mat-raised-button color="primary" (click)="backToList()">Back </button>
        </div>
      </span>
    </div>
    <div class="details-side-item">
      <span class="details-side-container">
        <div class="flex-row">
          <div class="flex-auto"><span class="form-label">Title: </span>
            <span class="form-field">{{ book().title }}</span>
          </div>
          <div class="flex-auto"><span class="form-label">Type: </span>
            <span class="form-field">{{ book().type }}</span>
          </div>
          @if (isLoggedIn()) {
          <div class="flex-auto">
            <button mat-raised-button color="primary" name="EditBtn" (click)='onEditClick($event)'>Edit</button>
          </div>
          }
        </div>
        @if (book().description) {
        <div class="flex-row">
          <div class="description" [innerHTML]="mdt(book().description!)"></div>
        </div>
        }
        <div class="flex-row-single"><span class="form-label">Authors: </span>
          <div *ngFor="let author of book().authors" class="chip-field">{{ author }}</div>
        </div>
        @if (book().type == 'Audible Book') {
        <div class="flex-row-single"><span class="form-label">Narrators: </span>
          @for( narrator of book().narrators; track narrator) {
          <div class="chip-field">{{ narrator }}
          </div>
          }
        </div>
        }
        <div class="flex-row">
          @if(book().type == 'Audible Book') {
          <div class="flex-auto">
            <span class="form-label">Running Time: </span><span class="form-field">{{
              book().runningTime }}</span>
          </div>
          }
          @else {
          <div class="flex-auto">
            <span class="form-label">Page Count: </span><span class="form-field">{{
              book().runningTime }}</span>
          </div>
          }
          <div class="flex-auto"><span class="form-label">Purchase Date: </span><span class="form-field">{{
              book().purchaseDate | date :
              'mediumDate'}}</span></div>
          <div class="flex-auto"><span class="form-label">Publication Date: </span><span class="form-field">{{
              book().publicationDate | date
              }}</span></div>
          <p><span class="form-label">Publisher: </span><span class="form-field">{{ book().publisher }}</span></p>
        </div>
        @if (book() && book().series && book().series!.length > 0) {
        <div class="flex-row-single" >
          <span class="form-label">Series: </span>
          @for(s of book().series; track s) {
          <div  class="form-field">
            {{ s.name }} -- Book {{ s.readingOrder}}
          </div>
        }
        </div>
      }
      @if (isLoggedIn()) {
        <div class="flex-row" >
          <div class="flex-auto"><span class="form-label">Added By: </span><span class="form-field">{{ book().addedBy
              }}</span></div>
          <div class="flex-auto"><span class="form-label">Is Interested: </span><span class="form-field">{{
              book().isInterested }}</span></div>
          <div class="flex-auto"><span class="form-label">Has Read: </span><span class="form-field">{{ book().hasRead
              }}</span></div>
        </div>
      }
      @if(isLoggedIn() && book() && book().recommendations && book().recommendations!.length > 0) {
        <div class="flex-auto" >
          <span class="form-label">Recommendations: </span>
          <table>
            <tr>
              <th>To:</th>
              <th>From:</th>
            </tr>
            @for( rec of book().recommendations; track rec) {
            <tr >
              <td>{{ rec.to }}</td>
              <td>{{ rec.from }}</td>
            </tr>
          }
          </table>
        </div>
      }
      @if (book() && book().genres && book().genres!.length > 0) {
        <div class="flex-row-single" ><span class="form-label">Genre(s): </span>
          <div *ngFor="let genre of book().genres" class="chip-field">{{ genre }}</div>
        </div>
      }
        <div class="flex-row">
          <div class="flex-auto"><span class="form-label">Amazon ID: </span><br /><span class="form-field-plain">{{
              book().amazon_id }}</span></div>
          <div class="flex-auto"><span class="form-label">Amazon Page: </span><br /><a href="{{ book().amazonPageUrl }}"
              class="form-field-plain" target="_blank">{{ book().amazonPageUrl }}</a></div>
        </div>
      </span>
    </div>
  </div>